<template>
  <v-menu
    v-model="displayMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
  >
    <v-list
      dense
      rounded
    >
      <v-subheader>
        <h3
          class="primary--text"
        >
          {{ displayAsSingular }} Menu
        </h3>
      </v-subheader>

      <v-list-item-group
        v-model="selectedMenu"
        color="primary"
      >
        <!-- Archive -->
        <v-list-item
          v-if="showArchiveOption"
          :disabled="maintenanceItems.selected.length > 0 ? false : true"
          @click="menuArchive_onClick()"
        >
          <v-list-item-icon>
            <v-icon
              small
              color="primary"
            >
              mdi-archive-arrow-down
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            Archive Selected
          </v-list-item-content>
        </v-list-item>
        <!-- New -->
        <v-list-item
          @click="menuNew_onClick()"
        >
          <v-list-item-icon>
            <v-icon
              small
              color="primary"
            >
              mdi-plus
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            New {{ displayAsSingular }}
          </v-list-item-content>
        </v-list-item>
        <!-- Edit -->
        <v-list-item
          @click="menuEdit_onClick()"
        >
          <v-list-item-icon>
            <v-icon
              small
              color="primary"
            >
              mdi-pencil
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <div
              v-if="selectedItem"
            >
              Edit {{ displayAsSingular }} - {{ selectedItem.description }}
            </div>
            <div v-else>
              Edit {{ displayAsSingular }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <!-- Delete -->
        <v-list-item
          v-if="showDeleteOption"
          :disabled="maintenanceItems.selected.length > 0 ? false : true"
          @click="menuDelete_onClick()"
        >
          <v-list-item-icon>
            <v-icon
              small
              color="primary"
            >
              mdi-delete-sweep-outline
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            Delete Selected
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'ContextMenu',

    props: {
      maintenanceItems: {
        type: Object,
        default: null,
      },
      displayAsSingular: {
        type: String,
        default: 'Item',
      },
      displayAsPlural: {
        type: String,
        default: 'Items',
      },
      showArchiveOption: {
        type: Boolean,
        default: false,
      },
      showDeleteOption: {
        type: Boolean,
        default: true,
      },
    },

    data () {
      return {
        displayMenu: null,
        x: 0,
        y: 0,
        selectedMenu: null,
        selectedItem: null,
      }
    },

    methods: {
      setSelectedMenu (val) {
        this.selectedMenu = val
      },

      openContextMenu (evt, dataItem) {
        evt.preventDefault()
        this.displayMenu = false
        this.x = evt.clientX
        this.y = evt.clientY
        this.selectedItem = dataItem
        this.$nextTick(() => {
          this.displayMenu = true
        })
      },

      menuArchive_onClick () {
        this.$emit('archiveitem')
      },

      menuNew_onClick () {
        this.$emit('newitem')
      },

      menuEdit_onClick () {
        this.$emit('edititem', this.selectedItem)
      },

      menuDelete_onClick () {
        this.$emit('deleteitem')
      },
    },
  }
</script>
